import crypto from 'crypto';

/**
 * Generate a random string of either alpha or alphanumeric characters
 * @param length
 * @param format
 * @returns {string}
 */
export const randomStringGenerator =(length: number = 40, format: 'alpha' | 'alphanum' ='alpha') => {
  const alphaChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const alphaNumericChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  if (length > 100 || length < 1) {
    console.error('Length must be between 1 and 100 characters');
    return;
  }

  let str = '';
  for (let i = 0; i < length; i++) {
    if (format == 'alpha') {
      const char = alphaChars.charAt(Math.random() * alphaChars.length);
      str += char;
    } else if (format == 'alphanum') {
      const char = alphaNumericChars.charAt(Math.random() * alphaNumericChars.length);
      str += char;
    }
  }

  return str;
};

export const hashedEmailGenerator = (companyName:string, length?: number = 40) => {
  const hash = crypto.createHash('sha256');
  hash.update(`${Date.now()}`);
  hash.update(`${companyName}`);

  return hash.digest('hex');
};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/util/emailGenerator.js